import { render, staticRenderFns } from "./AuditTable.vue?vue&type=template&id=d51968c0&scoped=true"
import script from "./AuditTable.vue?vue&type=script&lang=js"
export * from "./AuditTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d51968c0",
  null
  
)

export default component.exports